module.exports = __webpack_public_path__ + "img/digg.ec643835.svg";